/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState, useRef } from "react";
import { Card, Form, Button, Modal, InputGroup } from "react-bootstrap";
import { MailIcon, LockClosedIcon, UserIcon } from "@heroicons/react/solid";
import { TweetyWidget } from "../../../../widgets/tweety-widget-react-main";

export interface INewUserModalProps {
  showModal?: boolean;
  createStudentLabel?: string;
  onAcknowledgement?(
    email: string,
    firstName: string,
    lastName: string,
    tnc: boolean,
    role: string,
    phoneNumber: string,
  ): void;
  onDeny?(): void;
  fields: any;
  layout?: any;
  availableRole?: any;
  validatorConfig?: any;
}

export const NewUserModal = ({
  showModal,
  createStudentLabel,
  onDeny,
  onAcknowledgement, 
  fields,
  layout,
  availableRole,
  validatorConfig,
}: INewUserModalProps) => {
  const [show, setShow] = useState(showModal);

  const updateFieldsWithAvailableRole = (availableRole, fields) => {
    const checkBoxField = fields.find(field => field.type === "checkBox");
    if (checkBoxField) {
      checkBoxField.compProps.options = availableRole && availableRole.map(role => ({
        label: role.label,
        id: role.id
      }));
    }
    return fields;
  }

  const getRoleNameLable = () => {
    
  }
  const updatedFields = updateFieldsWithAvailableRole(availableRole, fields);

  const handleClose = () => {
    if (onDeny) {
      onDeny();
    }
    setShow(false);
  };
  const _onFormSubmit = (event: any) => {
    if (event) {
      if (onAcknowledgement) {
        onAcknowledgement(
          event?.email,
          event?.firstName,
          event?.lastName,
          true,
          // event?.role,
          // event?.phoneNumber
        );
      }
    }
    setShow(false);
  };

  return (
    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header className="border-0">
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="p-0">
        <Card border="light" className="px-0 px-md-4 py-0 border-0">
          <Card.Header className="text-center text-md-center border-0 mb-0 mt-md-0">
            <h4>{createStudentLabel}</h4>
          </Card.Header>
          <Card.Body>
          <TweetyWidget
              labelColor={"#000000"}
              fields={updatedFields}
              layout={layout}
              validatorConfig={validatorConfig}
              submitButtonLabel={"Blacklist User"}
              submitButtonStyle={{ width: "100%" }}
              submitButtonContainerStyle={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
              }}
              onFormSubmit={_onFormSubmit}
            />
          </Card.Body>
        </Card>
      </Modal.Body>
    </Modal>
  );
};

NewUserModal.defaultProps = {
  showModal: false,
  createStudentLabel: "Blacklist User",
};
